import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../../constants/AuthConstant";
import kodeOKService from "../../../services/ref/kodeOKService";
import Cookies from "js-cookie";

export const initialState = {
    loading_kode_ok: false,
    data_kode_ok: [],
    showMessage:false,
    message:'',
}


export const getDataKodeOK = createAsyncThunk('kode_ok/data',async (data, { rejectWithValue }) => {
    try {
        const response = await kodeOKService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})


export const kodeOKSlice = createSlice({
    name: 'kode_ok',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_kode_ok = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataKodeOK.fulfilled, (state, action) => {
                state.loading_kode_ok = false
                state.data_kode_ok = action.payload??[]
            })
            .addCase(getDataKodeOK.pending, (state) => {
                state.loading_kode_ok = true
            })
            .addCase(getDataKodeOK.rejected, (state, action) => {
                state.loading_kode_ok = false
                state.data_kode_ok = action.payload
            })
    },
})

export const {
    showLoading,
} = kodeOKSlice.actions

export default kodeOKSlice.reducer
